import { ApiService } from "@/services/api/ApiService";
import type { InactiveGenieFilters, InactiveGenieListResponse } from "@/types/admin/inactive-genies";

export class InactiveGenieAdminService {
  static async list(filters: InactiveGenieFilters, limit: number, offset: number): Promise<InactiveGenieListResponse> {
    const response = await ApiService.invoke<InactiveGenieListResponse>({
      resource: "genies",
      action: "admin-inactive",
      data: { ...filters, limit, offset },
    });
    return {
      genies: response?.genies ?? [],
      count: response?.count ?? 0,
      days: response?.days ?? filters.days,
      limit: response?.limit ?? limit,
      offset: response?.offset ?? offset,
    };
  }
}
